import { NoteGetRequestParams, NoteSearchRequestQuery } from '@lio/api-types';

export const noteQueryKey = {
  get: ['note'] as const,
  getWithParams: (params: NoteGetRequestParams & { quoteId: string }) => [...noteQueryKey.get, params] as const,
  search: ['notes'] as const,
  searchWithParams: (params: NoteSearchRequestQuery) => [...noteQueryKey.search, params] as const,
};
